export function isValidDate(str) {
  let day, month, year;

  // Vérifier si c'est au format jj/mm/yyyy
  const regexDDMMYYYY = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const matchDDMMYYYY = str.match(regexDDMMYYYY);

  if (matchDDMMYYYY) {
    day = parseInt(matchDDMMYYYY[1], 10);
    month = parseInt(matchDDMMYYYY[2], 10);
    year = parseInt(matchDDMMYYYY[3], 10);
  } else {
    // Vérifier si c'est au format yyyy-mm-dd
    const regexYYYYMMDD = /^(\d{4})-(\d{2})-(\d{2})$/;
    const matchYYYYMMDD = str.match(regexYYYYMMDD);

    if (matchYYYYMMDD) {
      year = parseInt(matchYYYYMMDD[1], 10);
      month = parseInt(matchYYYYMMDD[2], 10);
      day = parseInt(matchYYYYMMDD[3], 10);
    } else {
      return false; // Aucun format valide trouvé
    }
  }

  // Vérifier les valeurs de base
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  // Vérifier que la date est valide avec l'objet Date
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day;
}

export function formatDateStringToDBDate(str) {
  const [day, month, year] = str.split('/');
  return `${year}-${month}-${day}`;
}

export function formatDateStringToFrenchDate(date_str) {
  const [year, month, date] = date_str.split('-');
  return `${date}/${month}/${year}`;
}

export function getFiscalYearStart() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  if (currentMonth >= 9) {
    return new Date(currentYear, 9, 1);
  } else {
    return new Date(currentYear - 1, 9, 1);
  }
}

export function formatDateTimeToFrenchDate(datetime_str) {
  if (!datetime_str) return '';
  const datePart = datetime_str.split('T')[0];
  return formatDateStringToFrenchDate(datePart);
}

export function isDateBeforeToday(dateStr) {
  if (!dateStr || !isValidDate(dateStr)) return false;

  let year, month, day;
  const regexDDMMYYYY = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const matchDDMMYYYY = dateStr.match(regexDDMMYYYY);

  if (matchDDMMYYYY) {
    day = parseInt(matchDDMMYYYY[1], 10);
    month = parseInt(matchDDMMYYYY[2], 10);
    year = parseInt(matchDDMMYYYY[3], 10);
  } else {
    const regexYYYYMMDD = /^(\d{4})-(\d{2})-(\d{2})$/;
    const matchYYYYMMDD = dateStr.match(regexYYYYMMDD);

    if (matchYYYYMMDD) {
      year = parseInt(matchYYYYMMDD[1], 10);
      month = parseInt(matchYYYYMMDD[2], 10);
      day = parseInt(matchYYYYMMDD[3], 10);
    } else {
      return false;
    }
  }

  const inputDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return inputDate < today;
}

export function isDateAfterToday(dateStr) {
  if (!dateStr || !isValidDate(dateStr)) return false;

  let year, month, day;
  const regexDDMMYYYY = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const matchDDMMYYYY = dateStr.match(regexDDMMYYYY);

  if (matchDDMMYYYY) {
    day = parseInt(matchDDMMYYYY[1], 10);
    month = parseInt(matchDDMMYYYY[2], 10);
    year = parseInt(matchDDMMYYYY[3], 10);
  } else {
    const regexYYYYMMDD = /^(\d{4})-(\d{2})-(\d{2})$/;
    const matchYYYYMMDD = dateStr.match(regexYYYYMMDD);

    if (matchYYYYMMDD) {
      year = parseInt(matchYYYYMMDD[1], 10);
      month = parseInt(matchYYYYMMDD[2], 10);
      day = parseInt(matchYYYYMMDD[3], 10);
    } else {
      return false;
    }
  }

  const inputDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return inputDate > today;
}
